module.exports = __webpack_public_path__ + "img/solomon_islands.31e67e3.webp";